module.exports = __webpack_public_path__ + "img/absolut-age-confirm-mobile-img.77c7a585.png";